<template>
  <li class="card">
    <slot></slot>
  </li>
</template>
<style scoped></style>
